// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3fe98489","186":"036f7753","215":"46a71e49","372":"cd87de08","377":"3e832248","630":"4a426d62","738":"85161753","841":"10bbfd4b","851":"84e788c4","856":"8db351c3"}[chunkId] + ".chunk.js";
};